"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_1 = require("./styled");
const page_section_1 = __importDefault(require("~components/page-section"));
const ui_1 = require("@phishtool/ui");
const paragraph_1 = require("~components/paragraph");
const squareDimensions = {
    width: 18,
    height: 18,
};
const dimensionsMap = {
    reddit: squareDimensions,
    web: squareDimensions,
    'linked-in': squareDimensions,
    twitter: {
        width: 20,
        height: 18,
    },
};
const TestimonialContent = ({ content }) => ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: content.map((contentItem, index) => ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [contentItem.nodeType === 'text' && (0, jsx_runtime_1.jsx)("span", { children: contentItem.value }), contentItem.nodeType === 'hyperlink' && ((0, jsx_runtime_1.jsx)(styled_1.StyledTestimonialLink, { href: contentItem.data.uri, target: "_blank", onClick: (e) => e.stopPropagation(), children: (0, jsx_runtime_1.jsx)(TestimonialContent, { content: contentItem.content }) }))] }, index))) }));
const TestimonialComponent = ({ type, content, url }) => ((0, jsx_runtime_1.jsxs)(styled_1.StyledTestimonial, { tabIndex: 0, onClick: () => {
        var _a;
        (_a = window.open(url, '_blank')) === null || _a === void 0 ? void 0 : _a.focus();
    }, children: [(0, jsx_runtime_1.jsxs)(paragraph_1.Paragraph, { size: "large", spacer: 'x0', children: [(0, jsx_runtime_1.jsx)("span", { children: "\"" }), content.content.map((contentItem, index) => {
                    return ((0, jsx_runtime_1.jsx)(react_1.Fragment, { children: contentItem.nodeType === 'paragraph' && (0, jsx_runtime_1.jsx)(TestimonialContent, { content: contentItem.content }) }, index));
                }), (0, jsx_runtime_1.jsx)("span", { children: "\"" })] }), (0, jsx_runtime_1.jsx)(ui_1.Flex, { justify: ['flex-end', 'flex-start'], children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: type, size: dimensionsMap[type] }) })] }));
const Testimonials = ({ title, intro, testimonials }) => ((0, jsx_runtime_1.jsx)(page_section_1.default, { id: "testimonials", headerSpacer: ['x3', null, 'x9'], title: title, intro: intro, children: (0, jsx_runtime_1.jsx)(styled_1.StyledTestimonialsWrapper, { children: testimonials.map((testimonial, index) => ((0, jsx_runtime_1.jsx)(TestimonialComponent, Object.assign({}, testimonial), index))) }) }));
exports.default = Testimonials;
